export const MY_DAY_ROUTE = 'myday';
export const ROOM_PANEL_ROUTE = 'roompanel';
export const ORG_EXPLORER_ROUTE = 'orgexplorer';
export const MEETING_INSIGHTS_ROUTE = 'insights';
export const NOTES_PANE_ROUTE = 'notespane';
export const CALENDAR_WIDGET_ROUTE = 'calendarwidget';
export const TODO_WIDGET_ROUTE = 'todowidget';

export const ADD_CALENDAR_ROUTE = 'addcalendar';
export const PERSONAL_SPACE_ROUTE = 'personalspace';
export const SHARED_SPACE_ROUTE = 'sharedspace';
export const SHARED_SPACE_CONFIG_ROUTE = 'sharedspaceconfig';
export const LOCATION_CARD_ROUTE = 'locationcard';
export const CREATE_GROUP_ROUTE = 'creategroup';
export const ADD_MEMBERS_ROUTE = 'addmembers';
export const EDIT_GROUP_ROUTE = 'editgroup';
export const DISCOVER_GROUP_ROUTE = 'discovergroup';
export const INBOX_RULES_ROUTE = 'inboxrules';
export const DOWNLOAD_MOBILE_ROUTE = 'downloadmobile';
export const DATA_PROVIDER_ROUTE = 'dataprovider';
export const ACTIVITY_FEED_ROUTE = 'activityfeed';
export const YAMMER_ROUTE = 'yammer';
export const CREATE_BOOKINGS_CALENDAR_ROUTE = 'createbookingscalendar';

export type OpxRoute =
    | typeof MY_DAY_ROUTE
    | typeof ROOM_PANEL_ROUTE
    | typeof ORG_EXPLORER_ROUTE
    | typeof MEETING_INSIGHTS_ROUTE
    | typeof NOTES_PANE_ROUTE
    | typeof CALENDAR_WIDGET_ROUTE
    | typeof TODO_WIDGET_ROUTE
    | typeof CREATE_GROUP_ROUTE
    | typeof ADD_MEMBERS_ROUTE
    | typeof EDIT_GROUP_ROUTE
    | typeof DISCOVER_GROUP_ROUTE
    | typeof YAMMER_ROUTE
    | typeof TODO_WIDGET_ROUTE;

export type OpxDeeplinkRoute =
    | typeof ADD_CALENDAR_ROUTE
    | typeof MY_DAY_ROUTE
    | typeof PERSONAL_SPACE_ROUTE
    | typeof SHARED_SPACE_ROUTE
    | typeof SHARED_SPACE_CONFIG_ROUTE
    | typeof ROOM_PANEL_ROUTE
    | typeof MEETING_INSIGHTS_ROUTE
    | typeof LOCATION_CARD_ROUTE
    | typeof CREATE_GROUP_ROUTE
    | typeof ADD_MEMBERS_ROUTE
    | typeof EDIT_GROUP_ROUTE
    | typeof DISCOVER_GROUP_ROUTE
    | typeof INBOX_RULES_ROUTE
    | typeof DOWNLOAD_MOBILE_ROUTE
    | typeof DATA_PROVIDER_ROUTE
    | typeof ACTIVITY_FEED_ROUTE
    | typeof ORG_EXPLORER_ROUTE
    | typeof YAMMER_ROUTE
    | typeof CREATE_BOOKINGS_CALENDAR_ROUTE
    | typeof CALENDAR_WIDGET_ROUTE
    | typeof TODO_WIDGET_ROUTE;
